import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { global } from '../app.settings';

import { Event } from './model/event.model';
import { EventDetail } from './model/event-detail.model';
import { EmailDetail } from './model/email-detail.model';

@Injectable()
export class CommunicationService {

  constructor(private http: HttpClient) { }

  public documentType = {
    'doc': { synonyms: ['word'], icon: 'fa-file-word-o' },
    'docx': { synonyms: ['word'], icon: 'fa-file-word-o' },
    'xls': { synonyms: ['spreadsheet', 'table'], icon: 'fa-file-excel-o' },
    'xlsx': { synonyms: ['spreadsheet', 'table'], icon: 'fa-file-excel-o' },
    'pdf': { synonyms: ['adobe'], icon: 'fa-file-pdf-o' },
    'zip': { synonyms: [], icon: 'fa-file-zip-o' },
    'jpeg': { synonyms: ['picture', 'image'], icon: 'fa-file-image-o' },
    'jpg': { synonyms: ['picture', 'image'], icon: 'fa-file-image-o' },
    'rtf': { synonyms: [], icon: 'fa-file-text' },
    'txt': { synonyms: ['text'], icon: 'fa-file-text-o' },
    'tif': { synonyms: ['image', 'picture'], icon: 'fa-file-image-o' },
    'wav': { synonyms: ['audio', 'sound'], icon: 'fa-audio-o' },
    'bmp': { synonyms: ['image', 'picture'], icon: 'fa-file-image-o' },
    'csv': { synonyms: ['table', 'spreadsheet'], icon: 'fa-file-excel-o' },
    'default': { synonyms: ['file'], icon: 'fa-file' }
  };

  public getEvents(crawfordRef: string): Observable<Event[]> {
    return this.http.get<Event[]>(global.apiUrl + 'claim/' + crawfordRef + '/events');
  }

  public getEventDetails(crawfordRef: string, eventId: string): Observable<EventDetail> {
    return this.http.get<EventDetail>(global.apiUrl + 'claim/' + crawfordRef + '/events/' + eventId);
  }

  public getEmailDetails(crawfordRef: string, eventId: string): Observable<EmailDetail> {
    return this.http.get<EmailDetail>(global.apiUrl + 'claim/' + crawfordRef + '/events/' + eventId + '/email');
  }

  public getOpenDocument(crawfordRef: string, eventId: string): Observable<any> {
    return this.http.get(global.apiUrl + 'claim/' + crawfordRef + '/document/' + eventId,
      { observe: 'response', responseType: 'arraybuffer' });
  }

  public getDocuments(crawfordRef: string): Observable<Event[]> {
    return this.http.get<Event[]>(global.apiUrl + 'claim/' + crawfordRef + '/documents');
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/communication/communication.service.ts